import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceTypeService } from '@services/device-type.service';

export interface FormModalStructure {
  name: string;
  type: string;
  value: any;
  disabled: boolean;
}

@Component({
  selector: 'app-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.scss'],
  standalone: false,
})
export class FormModalComponent implements OnInit {
  alertType: string = '';
  @Input() showUserIcon: boolean = false;
  @Input() userName: string = '';
  @Input() backgroundColor: string = ''; // example: #ff00ff
  @Input() imagPath: string = '';
  @Input() avatarType: 'text' | 'image' = 'text';
  @Input() minColorRGB: number = 0;
  @Input() maxColorRGB: number = 255;
  @Input() title: string = '';
  @Input() formStructure!: FormModalStructure[];

  constructor(
    protected activeModal: NgbActiveModal,
    public deviceType: DeviceTypeService,
  ) {}

  close() {
    this.activeModal.close('doAction');
  }

  dismiss() {
    this.activeModal.close('close');
  }

  ngOnInit(): void {}
}
